<template>
    <v-app-bar>
        <v-toolbar-title>Actuando como:</v-toolbar-title>
        <v-spacer/>
        <therapist-select></therapist-select>
        <v-spacer/>
    </v-app-bar>
</template>

<script>
import TherapistSelect from "@/views/TherapistSelect.vue";

export default {
    name: "ImpersonatingNavBar",
    components: {TherapistSelect},

}
</script>

<style scoped>

</style>
